import {
  FormControl,
  FormHelperText,
  TextField,
  Typography
} from '@mui/material'
import React from 'react'
import { Controller, useFormContext, get } from 'react-hook-form'

export const ControlledTextField = ({
  name,
  defaultValue = '',
  label,
  helperText,
  multiline,
  prefix,
  ...rest
}) => {
  const { control, formState } = useFormContext()

  const error = get(formState.errors, name)
  const hasError = error !== undefined
  return (
    <>
      {multiline && (
        <Typography variant='body1' style={{ paddingBottom: 8 }}>
          {label}
        </Typography>
      )}
      <FormControl fullWidth size='small'>
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue}
          render={({ field: { onChange, value, onBlur, ref } }) => {
            const handleChange = e => {
              const value = e.target.value
              let prefixed = value
              if (prefix !== undefined && value !== '') {
                prefixed =
                  value.indexOf(prefix) === -1 ? `${prefix}${value}` : value
              }
              onChange(prefixed)
            }
            return (
              <TextField
                multiline={multiline}
                onChange={handleChange}
                value={value}
                label={multiline ? undefined : label}
                error={hasError}
                size='small'
                inputRef={ref}
                onBlur={onBlur}
                {...rest}
              />
            )
          }}
        />
        {helperText !== undefined && !hasError && (
          <FormHelperText id={`helper-text-${name}`}>
            {helperText}
          </FormHelperText>
        )}
        {error?.message !== undefined && (
          <FormHelperText
            id={`error-helper-text-${name}`}
            error
            style={{ textAlign: 'right', paddingRight: 8 }}
          >
            {error?.message}
          </FormHelperText>
        )}
      </FormControl>
    </>
  )
}
